import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { createSelector } from 'reselect';
/**
 * customerCurrencyCode comes from from the portal and is present only if the user has used a particular
 * currency to make a purchase, or they have a website with a domain name tied to a specific country.
 */
const customerCurrencyCodeSelector = ({
  customerCurrencyCode
}) => customerCurrencyCode;

/**
 * activeCurrencySelector is the current selected currency code from the UI.
 * If customerCurrencyCode exists however, customerCurrencyCode is always used since
 * we dont allow users to change currency, they are "locked in" to a specific one at this point.
 */
export const activeCurrencySelector = state => {
  // TODO: This hack is temporary. The types of activeCurrencyCode and customerCurrencyCode are not
  // what we would expect. Check where the type is breaking down.
  const {
    activeCurrencyCode
  } = state;
  const customerCurrencyCode = customerCurrencyCodeSelector(state);
  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }
  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
};
export const availableCurrenciesSelector = createSelector(customerCurrencyCodeSelector, customerCurrencyCode => {
  if (customerCurrencyCode) return [customerCurrencyCode];
  return Object.values(CurrencyCodes);
});

/**
 * defaultCurrencyCode is set only in fetchPurchaseMotionData() and does NOT get mutated ever.
 * It's the source of truth for the inital default currency code for in-app users.
 */
export const defaultCurrencySelector = ({
  defaultCurrencyCode
}) => defaultCurrencyCode;